<template>
  <BorderWrapper class="box mt-8 d-flex ga-6" :class="flexColumn">
    <section class="box account-page-container">
      <div class="user-info-container">
        <UserInfo />
      </div>
      <div class="table-container d-flex flex-column ga-3 w-100">
        <BaseFilterTab :filters="filters" />
        <div
          class="d-flex mb-2 justify-space-between ga-5 align-start w-100"
          :class="flexColumn"
        >
          <div class="d-flex ga-10 align-stretch mb-4" :class="flexColumn">
            <BaseSearch
              :placeholderText="placeHolderText"
              mode="round"
              minWidth="360"
            />
            <DateFilterGroup
              :fromDate="fromDate"
              :toDate="toDate"
              @update-from-date="updateFromDate"
              @update-to-date="updateToDate"
            />
          </div>
          <BaseButton
            @click="sendInvoiceDebRequest"
            :class="[isTablet || isMobile ? 'align-self-end' : '']"
            v-if="!isOrdersTabSelected"
            outlined
            paddingTop="10px"
            paddingBottom="10px"
            paddingLeft="14px"
            paddingRight="14px"
            width="fit-content"
          >
            <div class="d-flex align-center ga-1">
              <v-icon icon="mdi-file-download" color="#BD9478" />
              <span>{{ $t("AccountPage.downloadCatalogueBtn") }}</span>
            </div>
          </BaseButton>
        </div>
        <BaseTable
          :page="page"
          @update-page="updatePage"
          :isLoading="isLoadingTable"
          :numberOfPages="totalPages"
          :mode="mode"
          :headers="headers"
          :rows="rows"
        />
      </div>
    </section>
    <InvoiceDebtRequestModel
      :userEmail="getUserEmail"
      v-model="isInvoiceDebtRequestModelOpen"
    />
  </BorderWrapper>
</template>

<script>
import { mapGetters } from "vuex";
import UserInfo from "../helpers/AccountPage/UserInfo.vue";
import DateFilterGroup from "../helpers/DateFilterGroup.vue";
import BaseSearch from "../menus/BaseSearch.vue";
import BaseButton from "../UI/BaseButton.vue";
import BorderWrapper from "../UI/BorderWrapper.vue";
import BaseFilterTab from "../UI/filters/BaseFilterTab.vue";
import BaseTable from "../UI/tabels/BaseTable.vue";
import InvoiceService from "../../services/InvoiceService";
import moment from "moment";
import InvoiceDebtRequestModel from "../helpers/AccountPage/InvoiceDebtRequestModel.vue";

export default {
  components: {
    BorderWrapper,
    UserInfo,
    BaseTable,
    BaseFilterTab,
    BaseSearch,
    DateFilterGroup,
    BaseButton,
    InvoiceDebtRequestModel,
  },
  async mounted() {
    const toDate = this.$route.query?.toDate;
    const fromDate = this.$route.query?.fromDate;
    if (toDate) {
      this.toDate = moment(toDate, "DD/MM/YYYY").toDate();
    }

    if (fromDate) {
      this.fromDate = moment(fromDate, "DD/MM/YYYY").toDate();
    }
    this.getCustomerBalance();
    this.isLoadingTable = true;
    try {
      if (this.isOrdersTabSelected) {
        const count = await this.$store.dispatch(
          "Orders/getOrders",
          this.$route.query
        );
        this.numberOfRecords = count;
      } else {
        let invoiceRes = await InvoiceService.getInvoices(this.$route.query);
        invoiceRes = invoiceRes.data;
        this.numberOfRecords = invoiceRes.count;
        this.$store.dispatch("Invoices/updateInvoices", invoiceRes.invocies);
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.isLoadingTable = false;
    }
  },
  data() {
    return {
      fromDate: null,
      toDate: null,
      isInvoiceDebtRequestModelOpen: false,
      currentFilterTab: {},
      isLoadingTable: false,
      page: 1,
      numberOfRecords: 0,
      itemsPerPage: 5,
      filters: {
        1: {
          id: 1,
          icon: "mdi-text-box",
          name: this.$t("AccountPage.ordersFilterTab"),
          route: {
            path: "/account/orders",
          },
        },
        2: {
          id: 2,
          icon: "mdi-invoice-list",
          name: this.$t("AccountPage.invoicesFilterTab"),
          route: {
            path: "/account/invoices",
          },
        },
      },
    };
  },
  watch: {
    "$route.query": {
      async handler(newQuery) {
        if (newQuery.search) {
          this.page = 1;
          this.$router.push({
            query: {
              ...newQuery,
              page: 1,
            },
          });
        }
        try {
          this.isLoadingTable = true;
          if (this.isOrdersTabSelected) {
            const count = await this.$store.dispatch(
              "Orders/getOrders",
              newQuery
            );
            this.numberOfRecords = count;
          } else {
            let invoiceRes = await InvoiceService.getInvoices(newQuery);
            invoiceRes = invoiceRes.data;
            this.numberOfRecords = invoiceRes.count;
            this.$store.dispatch(
              "Invoices/updateInvoices",
              invoiceRes.invocies
            );
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          this.isLoadingTable = false;
        }
      },
      deep: true,
      immediate: false,
    },
  },
  methods: {
    async sendInvoiceDebRequest() {
      try {
        const isRequestSent = await this.$store.dispatch("Invoices/sendInvoiceDebtRequest");
        if(isRequestSent) this.isInvoiceDebtRequestModelOpen = true;
      } catch (error) {
        console.log(error);
      }
    },
    async getCustomerBalance() {
      try {
        await this.$store.dispatch("AuthModule/getCustomerBalance");
      } catch (error) {
        console.error("Error updating customer balance:", error);
      }
    },
    updatePage(newPage) {
      this.page = newPage;
      // Update URL with new page number while preserving other query params
      this.$router.replace({
        query: {
          ...this.$route.query,
          page: newPage,
        },
      });
    },
    updateFromDate(date) {
      this.fromDate = date;
      const query = {
        ...this.$route.query,
        page: 1,
      };
      if (date) {
        query.fromDate = moment(date).format("DD/MM/YYYY");
      } else {
        delete query.fromDate;
      }
      this.page = 1;
      this.$router.push({
        query: query,
      });
    },
    updateToDate(date) {
      this.toDate = date;
      console.log("updateToDate");
      console.log(date);
      const query = {
        ...this.$route.query,
        page: 1,
      };
      if (date) {
        query.toDate = moment(date).format("DD/MM/YYYY");
      } else {
        delete query.toDate;
      }
      this.page = 1;
      this.$router.push({
        query: query,
      });
    },
  },
  computed: {
    totalPages() {
      return Math.ceil(this.numberOfRecords / this.itemsPerPage);
    },
    ...mapGetters({
      getOrders: "Orders/getOrders",
      getInvoices: "Invoices/getInvoices",
      isTablet: "isTablet",
      isMobile: "isMobile",
      getUserEmail: "AuthModule/getUserEmail",
    }),
    flexColumn() {
      return this.isTablet || this.isMobile ? "flex-column" : "";
    },
    userInfoStyle() {
      return {
        minWidth: this.isTablet || this.isMobile ? "100%" : "381px",
      };
    },
    placeHolderText() {
      return this.isOrdersTabSelected
        ? this.$t("AccountPage.searchOrderPlaceHolder")
        : this.$t("AccountPage.searchInvoicePlaceHolder");
    },
    mode() {
      return this.isOrdersTabSelected ? "orders" : "invoices";
    },
    isInvoiceTabSelected() {
      return this.$route.path === "/account/invoices";
    },
    isOrdersTabSelected() {
      return this.$route.path === "/account/orders";
    },
    rows() {
      let rows = [];
      if (this.isOrdersTabSelected) {
        rows = this.getOrders;
      } else {
        rows = this.getInvoices;
      }
      return rows;
    },
    headers() {
      let headers = [];
      if (this.isOrdersTabSelected) {
        headers = [
          {
            id: 1,
            title: "הזמנה",
          },
          {
            id: 2,
            title: "תאריך יצירה",
          },
          {
            id: 3,
            title: "תאריך אספקה",
          },
          {
            id: 4,
            title: "הזמנתכם",
          },
          {
            id: 5,
            title: "סטטוס",
          },
          {
            id: 6,
            title: "סכום",
          },
          {
            id: 7,
            title: "פעולות",
          },
        ];
      } else {
        headers = [
          {
            id: 1,
            title: "חשבונית",
          },
          {
            id: 2,
            title: "תאריך יצירה",
          },
          {
            id: 3,
            title: "תאריך פרעון",
          },
          {
            id: 4,
            title: "סטטוס",
          },
          {
            id: 5,
            title: "סכום",
          },
          {
            id: 6,
            title: "פעולות",
          },
        ];
      }
      return headers;
    },
  },
};
</script>
<style lang="scss" scoped>
.account-page-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
}
.user-info-container {
  flex-basis: 25%;
}

.table-container {
  min-width: 70%;
  flex-basis: 70%;
}

@media (max-width: 1024px) {
  .account-page-container {
    flex-wrap: wrap;
    justify-content: center;
  }
  .table-container {
    min-width: unset;
    flex-basis: unset;
  }

  .user-info-container {
    flex-basis: 100%;
    max-width: 500px;
  }
}
</style>
